'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../../../components');
var _PhoneButton = require('./PhoneButton.scss');var _PhoneButton2 = _interopRequireDefault(_PhoneButton);
var _formatPhoneNumber = require('../../../../utils/formatPhoneNumber');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

PhoneButton = function (_Component) {_inherits(PhoneButton, _Component);
  function PhoneButton(props) {_classCallCheck(this, PhoneButton);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.














    getIsHoverDisabled = function () {var
      isMobile = _this.props.isMobile;var _this$state =
      _this.state,isPhoneRevealed = _this$state.isPhoneRevealed,isShowTooltip = _this$state.isShowTooltip;

      return isMobile || isPhoneRevealed || isShowTooltip;
    };_this.

    handleRevealPhone = function () {var _this$props =
      _this.props,onClick = _this$props.onClick,isMobile = _this$props.isMobile,phone = _this$props.phone;

      if (isMobile && phone) {
        window.location.href = 'tel:' + phone;
      }

      if (_this.state.isPhoneRevealed) return;


      if (onClick) {
        onClick();
      }

      _this.setState({
        isPhoneRevealed: true,
        isShowTooltip: !isMobile,
        isHovered: false });


      _this.timeoutId = setTimeout(function () {
        _this.setState({ isShowTooltip: false });
      }, 3000);
    };_this.

    handleMouseEnter = function () {
      var isHoverDisabled = _this.getIsHoverDisabled();

      if (isHoverDisabled) return;

      _this.setState({ isHovered: true });
    };_this.

    handleMouseLeave = function () {
      var isHoverDisabled = _this.getIsHoverDisabled();

      if (isHoverDisabled) return;

      _this.setState({ isHovered: false });
    };_this.

    renderTooltip = function () {var _this$props2 =
      _this.props,translate = _this$props2.translate,isMobile = _this$props2.isMobile;

      if (isMobile) {
        return null;
      }

      var title = translate('propertyDetails', 'contacts', 'onMapTitle').split(
      '%s');

      title.splice(
      1,
      0,
      _react2.default.createElement('span', { key: 'contacts', className: _PhoneButton2.default.logoTitle }, 'OnMap'));




      return title;
    };_this.

    renderHint = function () {var _this$props3 =
      _this.props,translate = _this$props3.translate,isMobile = _this$props3.isMobile;

      if (isMobile) {
        return null;
      }

      var title = translate('propertyDetails', 'contacts', 'phoneHoverTitle');

      return title;
    };_this.

    renderRevealedContent = function (prefixPhone, restPhone) {return (
        _react2.default.createElement('span', null,
          prefixPhone,
          restPhone && _react2.default.createElement('span', null, '\xA0', restPhone)));};_this.



    renderHiddenContent = function (prefixPhone, restPhone) {return (
        _react2.default.createElement('span', null,
          prefixPhone, '\xA0',
          restPhone &&
          _react2.default.createElement('span', null,
            restPhone.replace(/./g, 'X'))));};_this.timeoutId = null;_this.state = { isPhoneRevealed: false, isShowTooltip: false, isHovered: false };return _this;}PhoneButton.prototype.componentWillUnmount = function componentWillUnmount() {if (this.timeoutId) {clearTimeout(this.timeoutId);}};PhoneButton.prototype.





  render = function render() {var _cx;var _props =
    this.props,phone = _props.phone,locale = _props.locale;var _splitPhoneNumber =

    (0, _formatPhoneNumber.splitPhoneNumber)(phone),prefixPhone = _splitPhoneNumber.prefixPhone,restPhone = _splitPhoneNumber.restPhone;var _state =

    this.state,isPhoneRevealed = _state.isPhoneRevealed,isShowTooltip = _state.isShowTooltip,isHovered = _state.isHovered;

    return (
      _react2.default.createElement('button', {
          type: 'button',
          className: (0, _classnames2.default)(_PhoneButton2.default.phoneButton, (_cx = {}, _cx[
          _PhoneButton2.default.revealed] = isPhoneRevealed, _cx)),

          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onClick: this.handleRevealPhone },

        _react2.default.createElement('span', { className: (0, _classnames2.default)('icon icon-phone-fill', _PhoneButton2.default.iconsIndent) }),

        isPhoneRevealed ?
        this.renderRevealedContent(prefixPhone, restPhone) :
        this.renderHiddenContent(prefixPhone, restPhone),
        isShowTooltip &&
        _react2.default.createElement(_components.OMTooltip, {
          locale: locale,
          className: 'contact',
          msg: _react2.default.createElement('p', { className: _PhoneButton2.default.message }, this.renderTooltip()),
          hideCloseButton: true }),


        isHovered &&
        _react2.default.createElement(_components.OMTooltip, {
          locale: locale,
          className: 'contact',
          msg: _react2.default.createElement('p', { className: _PhoneButton2.default.message }, this.renderHint()),
          hideCloseButton: true })));




  };return PhoneButton;}(_react.Component);exports.default = PhoneButton;


PhoneButton.propTypes = {
  phone: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/PhoneButton/PhoneButton.js
// module id = 1225
// module chunks = 0